import React, { Component,Fragment } from 'react';
import './LessonEnd.module.scss';

import {lessonsData} from 'utilities/lessons';

import PageTitle from '../../components/UI/PageTitle/PageTitle'
import Button from '../../components/UI/Button/Button'
import ButtonFullWidth from '../../components/UI/ButtonFullWidth/ButtonFullWidth';
import LessonBlock from '../../components/UI/LessonBlock/LessonBlock'
import ButtonRight from '../../components/UI/ButtonRight/ButtonRight'
import SideNavigation from 'components/UI/SideNavigation/SideNavigation';
import TopNavigation from 'components/UI/TopNavigation/TopNavigation';
import PageWrapper from 'components/UI/PageWrapper/PageWrapper';
import BackgroundPolygons from 'components/UI/BackgroundPolygons/BackgroundPolygons';

class LessonEnd extends Component {
    render() {

        let lesson = lessonsData[this.props.match.params.lessonId - 1];
        var random = Math.floor((Math.random() * 24) + 1);

        return (
            <Fragment>
                <TopNavigation/>
                <SideNavigation/>
                <PageWrapper>
                    <div styleName='main'>
                        <BackgroundPolygons></BackgroundPolygons>
                        <div styleName='maxwidth'>
                            <PageTitle title={`${lesson.name} afgerond`} subtitle='Kijk verder naar de tips'/>
                            <div styleName='downloadblock'>
                                <div styleName='contentwrapper'>
                                    <div styleName='textwrapper'>
                                        <p>
                                            <b>Je kan dit ook nog proberen te maken!</b>
                                        </p>
                                        <p dangerouslySetInnerHTML={{__html: lesson.endInformation}}>
                                        </p>
                                    </div>
                                    <div styleName='random-celebration-gif' style={{backgroundImage: `url(/images/random-gif/${random}.gif)`}}>
                                    </div>
                                </div>
                                <div styleName='button-wrapper'>
                                <ButtonRight text='Terug naar lessen' link='/lessen'/>
                                </div>
                                
                                
                            </div>
                            
                        </div>
                    </div>
            </PageWrapper>
            </Fragment>
        );
    }
}

export default LessonEnd;


// WEBPACK FOOTER //
// ./resources/assets/screens/LessonEnd/LessonEnd.jsx